export default "__VITE_ASSET__BFWe1g1v__"